import { Injectable } from '@angular/core';
import { LocationAPIResponse, Location } from '../interfaces/location';
import { TelecomAdapter } from './telecom.adapter';
import { AddressAdapter } from './address.adapter';
import { HoursOperationAdapter } from './hoursOperatation.adapter';
import { OrganizationAdapter } from './organization.adapter';

@Injectable({
    providedIn: 'root'
}) @Injectable({
    providedIn: 'root'
})
export class LocationAdapter {

    constructor(
        private telecomAdapter: TelecomAdapter,
        private addressAdapter: AddressAdapter,
        private hoursOperationAdapter: HoursOperationAdapter,
        private organizationAdapter: OrganizationAdapter,
    ) {

    }

    public adapterToModel(locationFHIR: LocationAPIResponse): Location {

        const telecom = this.telecomAdapter.adapterToModel(locationFHIR.telecom)
        const address = this.addressAdapter.adapterToModel(locationFHIR.address[0])

        return {

            location_id: locationFHIR.location_id,
            name: locationFHIR.name,
            alias: locationFHIR.alias.join(','),
            organization_id: locationFHIR.managingOrganization.organization_id,
            organization: this.organizationAdapter.adapterToModel(locationFHIR.managingOrganization),
            managingOrganization: locationFHIR.managingOrganization,
            specialty: locationFHIR?.type?.[0]?.coding?.[0]?.display ?? '',
            mapUrl: locationFHIR.mapUrl,
            description: locationFHIR?.description,
            phone: telecom?.phone ?? undefined,
            mobile: telecom?.mobile ?? undefined,
            email: telecom?.email ?? undefined,
            address: address,
            position: locationFHIR.position,
            hoursOfOperation: this.hoursOperationAdapter.adapterToModel(locationFHIR?.hoursOfOperation ?? []),
            status: locationFHIR.status


        }


    }

    adaptToAPIFormat(locationModel: any): LocationAPIResponse {

        return {
            location_id: locationModel.location_id,
            status: locationModel.status ?? 'active',
            name: locationModel.name ?? locationModel.organization_name,
            alias: [locationModel.alias ?? locationModel.organization_name],
            description: locationModel?.organization_name,
            managingOrganization: locationModel.managingOrganization,
            organization_id: locationModel.organization_id ?? locationModel.organization.organization_id,
            mapUrl: locationModel.mapUrl,
            type: [{
                coding: [{
                    system: 'https://www.gov.br/pt-br/servicos/consultar-classificacao-brasileira-de-ocupacoes-cbo',
                    code: '8630-5/01',
                    display: locationModel.specialty
                }]
            }],
            telecom: this.telecomAdapter.adaptToAPIFormat(
                locationModel.email,
                locationModel.phone,
                locationModel.mobile,
            ),
            position: locationModel.position,
            hoursOfOperation: locationModel?.hoursOfOperation ? this.hoursOperationAdapter.adaptToAPIFormat(locationModel.hoursOfOperation) : [],
            address: this.addressAdapter.adaptToAPIFormat(locationModel.address)
        };


    }


}
